import { ChangeDetectionStrategy, Component } from "@angular/core";
import { NgOptimizedImage } from "@angular/common";
import { LogoComponent } from "@m19-board/shared/logo/logo.component";
import { IIconComponent } from "@front/m19-ui";

@Component({
  selector: "app-account-link-illustration",
  imports: [LogoComponent, NgOptimizedImage, IIconComponent],
  templateUrl: "./account-link-illustration.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountLinkIllustrationComponent {}
